import { useEffect, useRef, useState } from 'react';

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  const stats = [
    {
      number: 10,
      suffix: '+',
      label: 'Años de experiencia',
      icon: 'ri-calendar-line',
    },
    {
      number: 500,
      suffix: '+',
      label: 'Pisos vaciados',
      icon: 'ri-home-smile-line',
    },
    {
      number: 24,
      suffix: 'h',
      label: 'Servicio disponible',
      icon: 'ri-time-line',
    },
    {
      number: 100,
      suffix: '%',
      label: 'Satisfacción',
      icon: 'ri-star-smile-line',
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const Counter = ({ end, suffix }: { end: number; suffix: string }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (!isVisible) return;

      const duration = 2000;
      const steps = 60;
      const increment = end / steps;
      let current = 0;

      const timer = setInterval(() => {
        current += increment;
        if (current >= end) {
          setCount(end);
          clearInterval(timer);
        } else {
          setCount(Math.floor(current));
        }
      }, duration / steps);

      return () => clearInterval(timer);
    }, [isVisible, end]);

    return (
      <span>
        {count}
        {suffix}
      </span>
    );
  };

  return (
    <section
      ref={sectionRef}
      className="py-20 bg-gradient-to-br from-primary to-dark text-white relative overflow-hidden"
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Números que avalan nuestra experiencia
          </h2>
          <p className="text-lg text-white/90 max-w-3xl mx-auto">
            Más de una década ofreciendo servicios de <strong>vaciado de pisos</strong> y <strong>limpieza extrema</strong> en El Prat de Llobregat
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center transform hover:scale-105 transition-transform duration-300"
            >
              {/* Icon */}
              <div className="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mx-auto mb-4 backdrop-blur-sm">
                <i className={`${stat.icon} text-4xl`}></i>
              </div>

              {/* Number */}
              <div className="text-5xl md:text-6xl font-bold mb-2">
                <Counter end={stat.number} suffix={stat.suffix} />
              </div>

              {/* Label */}
              <div className="text-lg font-medium text-white/90">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
